module.exports = __webpack_public_path__ + "static/media/b_size.497f0d05.jpg";